import { render } from "./FaireTestPage.vue?vue&type=template&id=0f8e6388&ts=true"
import script from "./FaireTestPage.vue?vue&type=script&lang=ts"
export * from "./FaireTestPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__